package com.elan.edubridge.ui.staff

import com.elan.edubridge.shared.domain.policy.SubscriptionBannerVariant
import com.elan.edubridge.shared.domain.policy.subscriptionBannerVariant
import com.elan.edubridge.shared.domain.policy.trialDaysLeft

internal data class SubscriptionBannerContent(
    val message: String,
    val variant: String,
)

private const val TRIAL_MESSAGE = "무료체험 이용 중, 종료 후 자동 결제"

/**
 * 상태 필드가 없거나 정상·알 수 없는 상태면 기존 화면을 그대로 유지한다.
 *
 * 어떤 상태에서 띠를 띄우고 무료체험이 며칠 남았는지는 `:shared` 의
 * [subscriptionBannerVariant]·[trialDaysLeft] 가 정한다 — 안드로이드 관리자 앱이 같은 판정을 쓴다.
 * 여기 남는 것은 웹의 문구와 HTML 뿐이다.
 */
internal fun subscriptionBannerContent(
    state: String?,
    expiryTimeMillis: Double?,
    nowMillis: Double,
): SubscriptionBannerContent? = when (subscriptionBannerVariant(state)) {
    SubscriptionBannerVariant.TRIAL -> SubscriptionBannerContent(
        message = trialDaysLeft(expiryTimeMillis, nowMillis)
            ?.let { "$TRIAL_MESSAGE · D-$it" }
            ?: TRIAL_MESSAGE,
        variant = "trial",
    )
    SubscriptionBannerVariant.GRACE -> SubscriptionBannerContent(
        message = "결제에 문제가 있어요. Google Play에서 결제 수단을 확인해 주세요",
        variant = "grace",
    )
    SubscriptionBannerVariant.SUSPENDED -> SubscriptionBannerContent(
        message = "구독이 일시중지되어 신규 기록 작성이 제한됩니다. Google Play에서 재개해 주세요",
        variant = "suspended",
    )
    SubscriptionBannerVariant.WINDDOWN -> SubscriptionBannerContent(
        message = "구독이 만료되었습니다. 열람·내보내기는 유지되며 재구독 시 복구됩니다",
        variant = "winddown",
    )
    null -> null
}

internal fun subscriptionBannerHtml(content: SubscriptionBannerContent): String = """
    <aside class="eb-subscription-banner eb-subscription-banner--${content.variant}" role="status" aria-live="polite">
        ${content.message}
    </aside>
""".trimIndent()
